import React from 'react'

const UploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='currenColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_11432_113730)'>
      <path
        d='M6 1.69824L2.5 5.19824H4.5V8.19824H7.5V5.19824H9.5L6 1.69824ZM2.5 10.1982V9.19824H9.5V10.1982H2.5Z'
        fill='currentcolor'
      />
    </g>
    <defs>
      <clipPath id='clip0_11432_113730'>
        <rect
          width='12'
          height='12'
          fill='white'
          transform='translate(0 0.198242)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default UploadIcon
